import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { get } from "@/lib/format";

export function useResource(endpoint, { dataPath, enabled = true, params } = {}) {
  return useQuery({
    queryKey: ["resource", endpoint, params || null],
    enabled: enabled && !!endpoint,
    queryFn: async () => {
      const res = await api.get(endpoint, { params });
      const data = res.data;
      if (dataPath) return get(data, dataPath) || [];
      return data;
    },
    // Self-heal transient blips (shared-backend cold start / proxy hiccup) instead of
    // surfacing a scary "resource not found". Do not retry genuine client errors.
    retry: (failureCount, error) => {
      const s = error?.response?.status;
      if (s && s >= 400 && s < 500 && ![404, 408, 425, 429].includes(s)) return false;
      return failureCount < 2;
    },
    retryDelay: (n) => Math.min(800 * 2 ** n, 4000),
  });
}
